<script>
import Main from '@/mixins/main'
import {Tabbar, TabbarItem, ActionSheet, Field} from 'vant';

export default {
  mixins: [
    Main
  ],
  components: {
    [Field.name]: Field,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [ActionSheet.name]: ActionSheet
  },
  methods: {
    toAdminStations() {
      this.$router.push({path: '/admin/stations'});
    }
  }
}
</script>

<template>
  <div id="main">
    <router-view></router-view>

    <div v-if="chargingOrder" class="charging" @click="toCharge(chargingOrder.gunCode, chargingOrder.sn)">
      <div class="left">
        <battery/>
        <div class="status">充电中
          <template v-if="chargingOrder.opcode">(操作码:{{ chargingOrder.opcode }})</template>
        </div>
      </div>
      <div class="sdt-right"/>
    </div>

    <van-action-sheet closeable close-on-click-overlay v-model="showActionSheet" @cancel="inputMoneyConfirm" @close="showActionSheet = false" cancel-text="确定" description="预付金额充电">
      <van-field center clearable v-model="payToChargeMoney" type="number" label="预付金额" title-width="80px" placeholder="请输入预付充电金额" :border="false"></van-field>
      <div class="action-sheet-item-description">充电完成后，剩余金额自动原路退回，失败全额退回</div>
    </van-action-sheet>

    <div v-if="isManager" @click="toAdminStations" class="admin-into">管</div>

    <van-tabbar route active-color="#009251" inactive-color="#646464" class="tab-bar">
      <van-tabbar-item :to="{name: 'stations'}">
        <span>首页</span>
        <i slot="icon" class="sdt-home-active"></i>
      </van-tabbar-item>
      <van-tabbar-item :to="{name: 'goods'}">
        <span>商城</span>
        <i slot="icon" class="sdt-store"></i>
      </van-tabbar-item>
      <div class="scan-button">
        <div class="scan" :class="chargingOrder ? 'active' : ''" @click="scan">
          <div class="sdt-scan"/>
        </div>
      </div>
      <van-tabbar-item :to="{name: 'activities'}">
        <span>活动</span>
        <i slot="icon" class="sdt-activity"></i>
      </van-tabbar-item>
      <van-tabbar-item :to="{name: 'userCenter'}">
        <span>我的</span>
        <i slot="icon" class="sdt-user-center"></i>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<style scoped>

#main .charging {
  position: fixed;
  bottom: 61px;
  left: 0;
  right: 0;

  color: white;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: space-between;
}

#main .charging .left {
  display: flex;
  align-items: center;
}

#main .charging .left .status {
  margin-left: 4px;
  padding-bottom: 2px;
}

#main .action-sheet-item-description {
  color: #C2C2C2;
  font-size: 12px;
  padding: 0 16px 10px 16px;
}

#main .admin-into {
  z-index: 99999;
  position: fixed;
  right: 20px;
  top: 60%;

  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 18px;
  font-weight: 800;
  border-radius: 4px;
  background-color: #2b85e4;
}

#main .tab-bar {
  height: 64px;
}

#main .tab-bar .scan-button {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

#main .tab-bar .scan-button .scan {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background-color: #009251;
  display: flex;
  align-items: center;
  justify-content: center;
}

#main .tab-bar .scan-button .scan .sdt-scan {
  color: white;
  font-size: 26px;
  margin-left: 2px;
}

#main .tab-bar .scan-button .scan.active {
  background-color: #cc3300;
}
</style>